export default __webpack_public_path__ + "static/media/info.c76ee723.svg";